import React from 'react'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger'
type Size = 'sm' | 'md' | 'lg'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
  loading?: boolean
}

export function Button({ variant = 'primary', size = 'md', loading, children, disabled, style, ...props }: ButtonProps) {
  const base: React.CSSProperties = {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
    fontFamily: 'var(--font)', fontWeight: 500, borderRadius: 'var(--radius-s)',
    border: '1px solid transparent', cursor: disabled || loading ? 'not-allowed' : 'pointer',
    transition: 'all var(--transition-fast)', whiteSpace: 'nowrap',
    opacity: disabled || loading ? 0.5 : 1,
  }

  const sizes: Record<Size, React.CSSProperties> = {
    sm: { fontSize: '12px', padding: '4px 12px', lineHeight: '20px' },
    md: { fontSize: '14px', padding: '8px 16px', lineHeight: '24px' },
    lg: { fontSize: '16px', padding: '12px 24px', lineHeight: '24px' },
  }

  const variants: Record<Variant, React.CSSProperties> = {
    primary:   { background: 'var(--brand)', color: '#fff', borderColor: 'var(--brand)' },
    secondary: { background: 'transparent', color: 'var(--text-primary)', borderColor: 'var(--border)' },
    ghost:     { background: 'transparent', color: 'var(--text-secondary)', borderColor: 'transparent' },
    danger:    { background: 'var(--error)', color: '#fff', borderColor: 'var(--error)' },
  }

  return (
    <button disabled={disabled || loading} style={{ ...base, ...sizes[size], ...variants[variant], ...style }} {...props}>
      {loading ? '...' : children}
    </button>
  )
}
